import { makeStyles } from '@material-ui/core/styles';

export const useListItemStyles = makeStyles(
  theme => ({
    root: {
      padding: theme.spacing(1, 2),
      cursor: 'pointer',
      userSelect: 'none',
      '&:hover $menuButton': {
        opacity: 1,
        pointerEvents: 'auto'
      },
      '&:hover $pinnedIcon': {
        opacity: 0
      },
      '&:hover': {
        backgroundColor: theme.palette.action.hover
      },
      '&.Mui-selected': {
        backgroundColor: theme.palette.action.selected,
        '&:hover': {
          backgroundColor: theme.palette.action.selected
        }
      },
      '&.Mui-focusVisible:not(.Mui-selected)': {
        backgroundColor: 'transparent'
      }
    },
    listItemContent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      gap: theme.spacing(1),
      minHeight: 32
    },
    chatTitle: {
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.grey[700],
      flex: 1
    },
    actionsContainer: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto'
    },
    actionSlot: {
      position: 'relative',
      width: theme.spacing(3),
      height: theme.spacing(3),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    menuButton: {
      opacity: 0,
      pointerEvents: 'none',
      transition: 'opacity 150ms ease',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: theme.spacing(3),
      height: theme.spacing(3),
      padding: theme.spacing(0.25),
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.secondary,
      '&:hover': {
        backgroundColor: 'transparent',
        color: theme.palette.text.secondary
      }
    },
    menuButtonActive: {
      opacity: 1,
      pointerEvents: 'auto'
    },
    pinnedIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.grey[600],
      pointerEvents: 'none',
      transition: 'opacity 150ms ease'
    },
    pinnedIconHidden: {
      opacity: 0
    },
    deleteMenuItem: {
      color: theme.palette.error.main
    },
    editInput: {
      fontSize: theme.typography.body2.fontSize,
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.grey[700],
      userSelect: 'text'
    }
  }),
  { name: 'HistoryChatsListItem' }
);

export const usePopoverStyles = makeStyles(
  {
    root: {
      zIndex: '1400 !important'
    }
  },
  { name: 'HistoryChatsListItem-Popover' }
);
